var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnimate = function SvgAnimate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44579 4.42711L1.73132 0.678411C1.37828 0.446509 0.938482 0.440272 0.580067 0.662085C0.221652 0.883897 0 1.29946 0 1.74988V9.25012C0 9.70054 0.221652 10.1161 0.580067 10.3379C0.938482 10.5597 1.37828 10.5535 1.73132 10.3216L7.44579 6.57004C7.78965 6.34402 8 5.93736 8 5.49857C8 5.05978 7.78965 4.65312 7.44579 4.42711Z",
    fill: "#48A9A6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnimate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/animate.baefcffe5120b91e57b0462eb8e8d79c.blank.svg";